module.exports = __webpack_public_path__ + "img/PT269.91d212fe.png";